export const frequencyEnum = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
} as const

export type FrequencyEnum = (typeof frequencyEnum)[keyof typeof frequencyEnum]

export type Frequency = FrequencyEnum